module.exports = __webpack_public_path__ + "static/media/filterRowPeople.093847e3.txt";